import React from "react";

const ChatBodySkeleton = () => {
  return (
    <div className="chat-day-container chat-day-container-skeleton">
      <div
        className="chat-day-title skeleton-loading"
        style={{
          height: "21px",
          width: "100px",
          borderRadius: "var(--border-radius-sm)",
        }}
      ></div>
      <div className="chat-day-body">
        <GuestMsgSkeleton />
        <GuestMsgSkeleton marginBottom={16} />
        <HostMsgSkeleton marginBottom={16} />
        <GuestMsgSkeleton />
      </div>
    </div>
  );
};

export default ChatBodySkeleton;

function GuestMsgSkeleton({ marginBottom = 6 }) {
  return (
    <div
      className="skeleton-loading"
      style={{
        height: "40px",
        width: "50%",
        borderRadius: "var(--border-radius-sm)",
        marginLeft: "auto",
        marginBottom: `${marginBottom}px`,
      }}
    ></div>
  );
}

function HostMsgSkeleton({ marginBottom = 6 }) {
  return (
    <div
      className="skeleton-loading"
      style={{
        height: "40px",
        width: "50%",
        borderRadius: "var(--border-radius-sm)",
        marginBottom: `${marginBottom}px`,
      }}
    ></div>
  );
}
